export function waitForElem<T extends Element = HTMLElement>(selector: string): Promise<NodeListOf<T>> {
  /* Promise-based way to wait for DOM-element
   * to exist. When it does, run a callback. */
  return new Promise<NodeListOf<T>>((res) => {
    if (document.querySelector(selector)) {
      return res(document.querySelectorAll<T>(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        res(document.querySelectorAll<T>(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
